var map = {
	"./about-us-banner-cn.webp": 1537,
	"./about-us-banner-m-cn.webp": 1538,
	"./about-us-banner-m-ms.webp": 1539,
	"./about-us-banner-m.webp": 1540,
	"./about-us-banner-ms.webp": 1541,
	"./about-us-banner.webp": 467,
	"./banner-01.jpg": 1542,
	"./banner-slot.jpg": 1543,
	"./bet-and-earn-banner-cn.webp": 1544,
	"./bet-and-earn-banner-indon.webp": 1545,
	"./bet-and-earn-banner-ms.webp": 1546,
	"./bet-and-earn-banner.webp": 1547,
	"./check-in-banner-cn.webp": 1548,
	"./check-in-banner-id.webp": 1549,
	"./check-in-banner-ms.webp": 1550,
	"./check-in-banner.webp": 1551,
	"./cny_2024-bm.webp": 1552,
	"./cny_2024-cn.webp": 1553,
	"./cny_2024.webp": 1554,
	"./epl-banner-cn.webp": 1555,
	"./epl-banner-indo.webp": 1556,
	"./epl-banner-ms.webp": 1557,
	"./epl-banner.webp": 1558,
	"./games-banners-cn.webp": 1559,
	"./games-banners-ms.webp": 1560,
	"./games-banners.webp": 1561,
	"./lb-m-banner-cn.webp": 1562,
	"./lb-m-banner.webp": 1563,
	"./leaderboard-banner-cn.webp": 1564,
	"./leaderboard-banner.webp": 1565,
	"./lottery-banner.webp": 1566,
	"./lottery-banners-cn.webp": 1567,
	"./lottery-banners-ms.webp": 1568,
	"./lottery-banners.webp": 1569,
	"./lucky-spin-banner-cn.webp": 1570,
	"./lucky-spin-banner-ms.webp": 1571,
	"./lucky-spin-banner.webp": 1572,
	"./p2p-banner.webp": 1573,
	"./p2p-banners-cn.webp": 1574,
	"./p2p-banners-ms.webp": 1575,
	"./p2p-banners.webp": 1576,
	"./premier-league-banner-cn.webp": 1577,
	"./premier-league-banner.webp": 1578,
	"./promo-vip-banner-cn.webp": 1579,
	"./promo-vip-banner-ms.webp": 1580,
	"./promo-vip-banner.webp": 1581,
	"./promos-banner-cn.webp": 1582,
	"./promos-banner-indon.webp": 1583,
	"./promos-banner-ms.webp": 1584,
	"./promos-banner.webp": 1585,
	"./promos-detail-banner.jpg": 1586,
	"./side-bar-banner.jpg": 1587,
	"./slot-banners-cn.webp": 1588,
	"./slot-banners-ms.webp": 1589,
	"./slot-banners.webp": 1590,
	"./speed-banners-cn.webp": 1591,
	"./speed-banners-ms.webp": 1592,
	"./speed-banners.webp": 1593,
	"./vip-banner-cn.webp": 1594,
	"./vip-banner-id.webp": 1595,
	"./vip-banner-m-cn.webp": 1596,
	"./vip-banner-m-ms.webp": 1597,
	"./vip-banner-m.webp": 1598,
	"./vip-banner-ms.webp": 1599,
	"./vip-banner.webp": 1600,
	"./vip-deposit-marathon-challenges-cn.webp": 1601,
	"./vip-deposit-marathon-challenges-ms.webp": 1602,
	"./vip-deposit-marathon-challenges.webp": 1603,
	"./winner-leaderboard-banner-cn.webp": 1604,
	"./winner-leaderboard-banner.webp": 1605,
	"./world-cup-banner-cn.webp": 1606,
	"./world-cup-banner.webp": 1607,
	"./world-cup-two-banner-cn.webp": 1608,
	"./world-cup-two-banner.webp": 1609
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49;